module.exports = __webpack_public_path__ + "static/media/cpp.ad5146ef.png";